import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks';
import { Loading } from '../ui';
import { env } from '../../config';

export function RequireAuth({ children }) {
  const { data: user, isLoading, isFetching } = useAuth({ enabled: !env.features.authBypass })
  const loc = useLocation();

  // If auth bypass is enabled, render children directly
  if (env.features.authBypass) {
    return <>{children}</>;
  }

  // Show loading while checking authentication status
  if (isLoading || isFetching) {
    return <Loading messageKey="auth.checkSession" />;
  }

  // If user is not authenticated, redirect to login page (root path)
  if (!user) {
    return <Navigate to="/" replace state={{ from: loc.pathname }} />;
  }

  // User is authenticated, allow access to protected pages
  return <>{children}</>;
}
